import { FC } from "react"
import { AttentionsAnswer } from "../../../module/attentions/containers/answer"

export const AttentionsAnswerPage: FC = () => <AttentionsAnswer />
